import React, { useState, useEffect } from "react";
import "../../App.css";
import PageTitle from "../../Module/pageTitle";
import { useDispatch } from "react-redux";
import { sendPushNotificationData } from "../../Action/adminPanelAction";
import DatePicker from "../../Component/datePicker";
import moment from "moment";
import LabelField from "../../Component/labelField";
import CustomDropdown from "../../Component/customDropdown";
import { getCampaignList } from "../../Action/campaignAction";
import InputField from "../../Component/inputField";
function SendPushNotification() {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [campaign, setCampaign] = useState("");
  const [campaignList, setCampaignList] = useState([]);
  const [userCount, setUserCount] = useState("");
  useEffect(() => {
    const postData = {
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(
      getCampaignList(
        postData,
        (res) => {
          if (res) {
            console.log("getCampaignList", res);
            setCampaignList(res?.data);
          }
        },
        () => {}
      )
    );
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = {
      campaignId: campaign?._id,
    };

    dispatch(sendPushNotificationData(postData, async () => {}));
  };

  const onChangeStartDate = (val) => {
    setStartDate(val);
    const postData = {
      startDate: val,
      endDate: endDate,
    };
    dispatch(
      getCampaignList(
        postData,
        (res) => {
          if (res) {
            setCampaignList(res?.data);
          }
        },
        () => {}
      )
    );
  };
  const changeEndDate = (val) => {
    setEndDate(val);
    const postData = {
      startDate: startDate,
      endDate: val,
    };
    dispatch(
      getCampaignList(
        postData,
        (res) => {
          if (res) {
            setCampaignList(res?.data);
          }
        },
        () => {}
      )
    );
  };
  const onChangeCampaign = (val) => {
    setCampaign(val);
    setUserCount(val?.userCount);
  };
  const validations = () => {
    return (
      startDate === "" ||
      endDate === "" ||
      startDate > endDate ||
      !campaign ||
      userCount === ""
    );
  };

  const render = () => {
    return (
      <>
        <div className="row mb-3">
          <div className="col-4">
            <div className="d-flex mb-2 align-items-center">
              <label className="col-md-3 me-4 fw-bold"> Start Date:</label>
              <DatePicker
                setInputText={(value) => {
                  onChangeStartDate(value);
                }}
                value={startDate}
                Isrequired={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex mb-2 align-items-center">
              <label className="col-md-3 me-4 fw-bold"> End Date:</label>
              <DatePicker
                setInputText={(value) => changeEndDate(value)}
                value={endDate}
                Isrequired={true}
              />
            </div>
          </div>
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Select Campaign"} />
            <CustomDropdown
              labelName={"Select Campaign"}
              placeholder={"Select Campaign"}
              setInputText={(value) => onChangeCampaign(value)}
              value={campaign}
              options={campaignList}
            />
          </div>
          <div className="col-4">
            <InputField
              labelName="User Count"
              placeholder="User Count"
              value={userCount}
              setInputText={(value) => setUserCount(value)}
              disabled
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="contentBox">
      <PageTitle name={"Send Push Notification"} />
      <div className="row m-0">
        <div className="col-12 formDiv">
          <form className="p-3" onSubmit={handleSubmit}>
            <div className="col-auto">{render()}</div>
            <div className="col-auto d-flex justify-content-center mt-4">
              <button
                type="submit"
                className={`btn mb-3 submitbtn ${
                  validations() ? "btn-secondary" : "btn-primary"
                }`}
                disabled={validations()}
              >
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SendPushNotification;
